// Smart create-form defaults (critical-path speed pass, 2026-07-05): the
// form opens ALREADY FILLED with the most probable match — organizers only
// touch what differs. Two sources: padel prime-time heuristics (pure,
// frozen-clock tested) and the organizer's own last-used values.

const pad = (n: number) => String(n).padStart(2, '0')

/** The evening slots Spanish padel actually books — the quick-pick chips. */
export const PRIME_TIMES = ['18:00', '19:00', '20:00', '21:00'] as const

/**
 * Best-guess start for a match created NOW. Padel is an evening sport:
 * - before 17:00 → tonight 19:00 (the modal prime slot)
 * - 17:00–21:30 → the next half-hour ≥30 min away (organizing something soon)
 * - after 21:30 → tomorrow 19:00 (tonight is over)
 */
export function suggestStart(now: Date): { dayOffset: 0 | 1; time: string } {
  const h = now.getHours()
  const m = now.getMinutes()
  if (h < 17) return { dayOffset: 0, time: '19:00' }
  if (h > 21 || (h === 21 && m > 30)) return { dayOffset: 1, time: '19:00' }
  const rounded = Math.ceil((h * 60 + m + 30) / 30) * 30
  return { dayOffset: 0, time: `${pad(Math.floor(rounded / 60))}:${pad(rounded % 60)}` }
}

/** Last-used create values — repeat organizers keep their price/duration/
 *  group across matches without reaching for Repetir. */
export interface CreateMemory {
  price?: string
  duration?: '60' | '90' | '120'
  courtReserved?: boolean
  genderCat?: string
  waGroup?: string
}

const MEMORY_KEY = 'um-create-memory'

export function loadCreateMemory(): CreateMemory {
  try {
    return JSON.parse(localStorage.getItem(MEMORY_KEY) ?? '{}') as CreateMemory
  } catch {
    return {}
  }
}

export function saveCreateMemory(memory: CreateMemory): void {
  try {
    localStorage.setItem(MEMORY_KEY, JSON.stringify(memory))
  } catch {
    /* storage full/blocked — defaults just won't stick */
  }
}
